import { render, staticRenderFns } from "./UserProjectsModal.vue?vue&type=template&id=27a4a092&scoped=true&"
import script from "./UserProjectsModal.vue?vue&type=script&lang=js&"
export * from "./UserProjectsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserProjectsModal.vue?vue&type=style&index=0&id=27a4a092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4a092",
  null
  
)

export default component.exports